import { roles } from '@/main.config.js'
import i18n from '@/i18n.js'

const roleList = (() => {
  let obj = {}
  obj[roles.neuro] = {
    title: i18n.t('role.neuro')
  }
  obj[roles.doctor] = {
    title: i18n.t('role.doctor')
  }
  obj[roles.hospital] = {
    title: i18n.t('role.admin')
  }
  obj[roles.readonly] = {
    title: i18n.t('role.observer')
  }
  return obj
})()

const roleFilterList = (() => {
  let obj = Object.assign({}, roleList)
  obj[0] = {
    title: i18n.t('role.any')
  }
  delete obj[roles.neuro]
  return obj
})()

export { roleList, roleFilterList }
